import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import OptionsMenu, {
  OptionsMenuItem
} from "@pathwright/ux/src/components/menu/OptionsMenu"
import styled from "styled-components"
import NotificationFeedItem from "../NotificationFeedItem"
import NotificationsEmptyFeed from "../NotificationsEmptyFeed"
import { PaginateNotifications, filters } from "../NotificationsFeed"
import Feed from "../feed/Feed"
import { useNotificationsState } from "../state/notification-state"

const StyledFeed = styled(Feed)`
  overflow: visible;
  width: 100%;

  > .inner {
    padding: 0;
  }

  .FeedItemsContainer {
    width: 100%;
    max-height: unset;
    overflow: visible;

    > div {
      padding: 0;
    }

    .BlankSlate {
      max-width: 300px;
    }
  }
`

export function NotificationsControls() {
  const { t } = useTranslate()
  let { items, markRead } = useNotificationsState()

  const handleMarkAsRead = () => {
    markRead(items)
  }

  return (
    <OptionsMenu
      triggerProps={{
        "aria-label": "Notifications Options",
        colorPalette: "blackAlpha",
        variant: "surface",
        size: "xs"
      }}
      menuProps={{ positioning: { placement: "bottom-end" } }}
    >
      <OptionsMenuItem
        icon="envelope"
        label={t("Digest Settings")}
        relativeTo="settings"
      />
      <OptionsMenuItem
        icon="check"
        label={"Mark all as read"}
        onClick={handleMarkAsRead}
      />
    </OptionsMenu>
  )
}

function NotificationAugmentation() {
  let { items, setKey } = useNotificationsState()

  let feedItems = items
    .filter((item) => item.type === "item")
    .sort((a, b) => {
      return b.data.when - a.data.when
    })

  return (
    <StyledFeed
      className="Feed"
      items={feedItems}
      feedItemComponent={NotificationFeedItem}
      emptyFeedComponent={NotificationsEmptyFeed}
      paginateComponent={PaginateNotifications}
      controlsComponent={() => null}
      filters={filters}
      onFilter={setKey}
      // Make TS happy for now.
      onSelect={() => {}}
    />
  )
}

export default NotificationAugmentation
